import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, ProgressBar, Badge, Pagination, Modal } from 'react-bootstrap';
import { User, Heart, TrendingUp, Users, School, Award, Gift, Info, CheckCircle, Eye, ArrowRight } from 'lucide-react';
import '../../../assets/css/donor/dashboard/Dashboard.css';
import DonorLayout from '../../../layouts/donor/DonorLayout';

const Dashboard = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  
  const itemsPerPage = 5;

  // Donor info
  const donorInfo = {
    name: 'Ali Hassan',
    level: 'Gold',
    levelStars: 3,
    totalDonated: 120000,
    progressToNext: 70,
    nextLevel: 'Platinum',
    nextLevelAmount: 150000
  };

  // Stats
  const stats = {
    totalDonations: 120000,
    studentsHelped: 18,
    schoolsSupported: 6
  };

  // Verified student cases
  const allStudentCases = [
    {
      id: 1,
      studentName: 'Ali Ahmed',
      school: 'Govt High School',
      need: 'Fees + Books',
      requiredAmount: 25000,
      ngoVerified: true,
      ngo: 'EduCare NGO',
      location: 'Lahore',
      class: '10th Grade',
      reason: 'Father unemployed due to illness',
      documents: 4
    },
    {
      id: 2,
      studentName: 'Sara Khan',
      school: 'Punjab College',
      need: 'Uniform',
      requiredAmount: 12000,
      ngoVerified: true,
      ngo: 'Student Aid NGO',
      location: 'Faisalabad',
      class: 'Intermediate',
      reason: 'Single parent household',
      documents: 3
    },
    {
      id: 3,
      studentName: 'Hassan Raza',
      school: 'City Model School',
      need: 'Fees',
      requiredAmount: 18000,
      ngoVerified: true,
      ngo: 'EduCare NGO',
      location: 'Karachi',
      class: '9th Grade',
      reason: 'Family financial crisis',
      documents: 5
    },
    {
      id: 4,
      studentName: 'Fatima Ali',
      school: 'Sunrise Academy',
      need: 'Books',
      requiredAmount: 8000,
      ngoVerified: true,
      ngo: 'Knowledge Foundation',
      location: 'Islamabad',
      class: '8th Grade',
      reason: 'Cannot afford expensive books',
      documents: 2
    },
    {
      id: 5,
      studentName: 'Bilal Shah',
      school: 'National College',
      need: 'Fees + Uniform',
      requiredAmount: 30000,
      ngoVerified: true,
      ngo: 'EduCare NGO',
      location: 'Multan',
      class: 'A-Levels',
      reason: 'Lost family breadwinner',
      documents: 6
    },
    {
      id: 6,
      studentName: 'Aisha Malik',
      school: 'Federal School',
      need: 'Books',
      requiredAmount: 6000,
      ngoVerified: true,
      ngo: 'Student Aid NGO',
      location: 'Rawalpindi',
      class: '7th Grade',
      reason: 'Large family with limited income',
      documents: 3
    },
    {
      id: 7,
      studentName: 'Usman Khan',
      school: 'Elite College',
      need: 'Fees',
      requiredAmount: 22000,
      ngoVerified: true,
      ngo: 'EduCare NGO',
      location: 'Lahore',
      class: 'FSc',
      reason: 'Medical expenses exhausted savings',
      documents: 4
    }
  ];

  // Level rewards
  const levelRewards = [
    { level: 'Bronze', unlocked: true, amount: 0 },
    { level: 'Silver', unlocked: true, amount: 50000 },
    { level: 'Gold', unlocked: false, amount: 150000 },
    { level: 'Platinum', unlocked: false, amount: 200000 }
  ];

  // Pagination logic
  const totalPages = Math.ceil(allStudentCases.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentCases = allStudentCases.slice(startIndex, endIndex);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleViewDetails = (student) => {
    setSelectedStudent(student);
    setShowDetailModal(true);
  };

  const handleDonateToSchool = (student) => {
    alert(`Donating to ${student.school} for ${student.studentName}`);
  };

  return (
    <DonorLayout>
      <div className="donor-dash-new-container">
        <Container fluid>
          {/* Section 1: Donor Level & Summary */}
          {/* <Row className="mb-4">
            <Col>
              <Card className="donor-dash-new-level-card">
                <Card.Body>
                  <Row className="align-items-center">
                    <Col md={2} className="text-center">
                      <div className="donor-dash-new-avatar">
                        <User size={48} />
                      </div>
                    </Col>
                    <Col md={10}>
                      <h3 className="donor-dash-new-donor-name">{donorInfo.name}</h3>
                      <div className="donor-dash-new-level-info">
                        <span className="donor-dash-new-level-text">Level:</span>
                        <Badge bg="warning" className="donor-dash-new-level-badge">
                          {donorInfo.level} Donor
                        </Badge>
                        <span className="donor-dash-new-level-stars">
                          {Array(donorInfo.levelStars).fill('⭐').join('')}
                        </span>
                      </div>
                      
                      <div className="donor-dash-new-progress-section">
                        <div className="donor-dash-new-progress-header">
                          <span className="donor-dash-new-progress-label">
                            Progress to {donorInfo.nextLevel}:
                          </span>
                          <span className="donor-dash-new-progress-percent">
                            {donorInfo.progressToNext}%
                          </span>
                        </div>
                        <ProgressBar 
                          now={donorInfo.progressToNext} 
                          variant="warning"
                          className="donor-dash-new-progress-bar"
                        />
                        <p className="donor-dash-new-progress-text">
                          PKR {(donorInfo.nextLevelAmount - donorInfo.totalDonated).toLocaleString()} more to reach {donorInfo.nextLevel}
                        </p>
                      </div>

                      <div className="donor-dash-new-total-donated">
                        <span className="donor-dash-new-total-label">Total Donated:</span>
                        <span className="donor-dash-new-total-amount">
                          PKR {donorInfo.totalDonated.toLocaleString()}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row> */}

          {/* Section 2: Quick Stats Cards */}
          <Row className="mb-4 g-3">
            <Col lg={4} md={4} className="d-flex">
              <Card className="donor-dash-new-stat-card w-100">
                <Card.Body>
                  <div className="donor-dash-new-stat-icon donor-dash-new-stat-icon-primary">
                    <TrendingUp size={28} />
                  </div>
                  <h3 className="donor-dash-new-stat-value">
                    PKR {(stats.totalDonations / 1000).toFixed(0)}k
                  </h3>
                  <p className="donor-dash-new-stat-label">Total Donations</p>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} className="d-flex">
              <Card className="donor-dash-new-stat-card w-100">
                <Card.Body>
                  <div className="donor-dash-new-stat-icon donor-dash-new-stat-icon-success">
                    <Users size={28} />
                  </div>
                  <h3 className="donor-dash-new-stat-value">{stats.studentsHelped}</h3>
                  <p className="donor-dash-new-stat-label">Students Helped</p>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} className="d-flex">
              <Card className="donor-dash-new-stat-card w-100">
                <Card.Body>
                  <div className="donor-dash-new-stat-icon donor-dash-new-stat-icon-orange">
                    <School size={28} />
                  </div>
                  <h3 className="donor-dash-new-stat-value">{stats.schoolsSupported}</h3>
                  <p className="donor-dash-new-stat-label">Schools Supported</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Section 3: Verified Student Cases (Table) */}
          <Row className="mb-4">
            <Col>
              <Card className="donor-dash-new-cases-card">
                <Card.Body>
                  <div className="donor-dash-new-section-header">
                    <h4 className="donor-dash-new-section-title">
                      <CheckCircle size={22} className="me-2" />
                      Verified Student Cases
                    </h4>
                  </div>

                  <div className="donor-dash-new-table-wrapper">
                    <table className="donor-dash-new-table">
                      <thead className="donor-dash-new-table-header">
                        <tr>
                          <th>Student Name</th>
                          <th>School/College</th>
                          <th>Need</th>
                          <th>Required Amount</th>
                          <th>NGO Verified</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody className="donor-dash-new-table-body">
                        {currentCases.map((student) => (
                          <tr key={student.id} className="donor-dash-new-table-row">
                            <td className="donor-dash-new-td">
                              <span className="donor-dash-new-student-name">
                                {student.studentName}
                              </span>
                            </td>
                            <td className="donor-dash-new-td">
                              <span className="donor-dash-new-school-name">
                                {student.school}
                              </span>
                            </td>
                            <td className="donor-dash-new-td">
                              <Badge bg="info" className="donor-dash-new-need-badge">
                                {student.need}
                              </Badge>
                            </td>
                            <td className="donor-dash-new-td">
                              <span className="donor-dash-new-amount">
                                PKR {student.requiredAmount.toLocaleString()}
                              </span>
                            </td>
                            <td className="donor-dash-new-td">
                              <div className="donor-dash-new-verified-cell">
                                <CheckCircle size={16} className="donor-dash-new-check-icon" />
                                <span className="donor-dash-new-ngo-text">{student.ngo}</span>
                              </div>
                            </td>
                            <td className="donor-dash-new-td">
                              <div className="donor-dash-new-action-btns">
                                <Button 
                                  size="sm"
                                  className="donor-dash-new-view-btn"
                                  onClick={() => handleViewDetails(student)}
                                >
                                  <Eye size={14} /> View
                                </Button>
                                <Button 
                                  size="sm"
                                  className="donor-dash-new-donate-btn"
                                  onClick={() => handleDonateToSchool(student)}
                                >
                                  <Heart size={14} /> Donate
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="donor-dash-new-pagination-wrapper">
                    <Pagination className="donor-dash-new-pagination">
                      <Pagination.Prev 
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      />
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <Pagination.Item
                          key={page}
                          active={page === currentPage}
                          onClick={() => handlePageChange(page)}
                          className="donor-dash-new-page-item"
                        >
                          {page}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next 
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      />
                    </Pagination>

                    <Button 
                      variant="outline-primary"
                      className="donor-dash-new-view-all-btn"
                    >
                      View All Cases <ArrowRight size={16} />
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Section 4: Donation Transparency Info */}
          <Row className="mb-4">
            <Col>
              <Card className="donor-dash-new-transparency-card">
                <Card.Body>
                  <div className="donor-dash-new-transparency-content">
                    <Info size={24} className="donor-dash-new-info-icon" />
                    <div className="donor-dash-new-transparency-text">
                      <p className="donor-dash-new-transparency-main">
                        Your donation is sent directly to the student's school/college account.
                      </p>
                      <p className="donor-dash-new-transparency-sub">
                        Students do NOT receive cash directly.
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Section 5: Rewards Preview */}
          <Row className="mb-4">
            <Col>
              <Card className="donor-dash-new-rewards-card">
                <Card.Body>
                  <div className="donor-dash-new-section-header">
                    <h4 className="donor-dash-new-section-title">
                      <Gift size={22} className="me-2" />
                      Your Level Rewards
                    </h4>
                  </div>

                  <div className="donor-dash-new-rewards-grid">
                    {levelRewards.map((reward, index) => (
                      <div 
                        key={index}
                        className={`donor-dash-new-reward-item ${reward.unlocked ? 'unlocked' : 'locked'}`}
                      >
                        <div className="donor-dash-new-reward-level">{reward.level}</div>
                        <div className="donor-dash-new-reward-status">
                          {reward.unlocked ? (
                            <CheckCircle size={20} className="donor-dash-new-unlock-icon" />
                          ) : (
                            <span className="donor-dash-new-lock-icon">🔒</span>
                          )}
                        </div>
                        {!reward.unlocked && reward.amount > 0 && (
                          <small className="donor-dash-new-reward-unlock-text">
                            Unlock at PKR {reward.amount.toLocaleString()}
                          </small>
                        )}
                      </div>
                    ))}
                  </div>

                  <div className="text-center mt-3">
                    <Button className="donor-dash-new-full-rewards-btn">
                      <Award size={18} />
                      View Full Rewards
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Student Detail Modal */}
        {selectedStudent && (
          <Modal 
            show={showDetailModal} 
            onHide={() => setShowDetailModal(false)}
            centered
            size="lg"
          >
            <Modal.Header closeButton className="donor-dash-new-modal-header">
              <Modal.Title>Student Details</Modal.Title>
            </Modal.Header>
            <Modal.Body className="donor-dash-new-modal-body">
              <div className="donor-dash-new-detail-avatar">
                <User size={64} />
              </div>
              
              <h4 className="donor-dash-new-detail-name">{selectedStudent.studentName}</h4>
              
              <Badge bg="info" className="mb-3">{selectedStudent.need}</Badge>

              <div className="donor-dash-new-detail-grid">
                <div className="donor-dash-new-detail-item">
                  <label>School/College</label>
                  <span>{selectedStudent.school}</span>
                </div>
                <div className="donor-dash-new-detail-item">
                  <label>Class</label>
                  <span>{selectedStudent.class}</span>
                </div>
                <div className="donor-dash-new-detail-item">
                  <label>Location</label>
                  <span>{selectedStudent.location}</span>
                </div>
                <div className="donor-dash-new-detail-item">
                  <label>Required Amount</label>
                  <span className="donor-dash-new-detail-amount">
                    PKR {selectedStudent.requiredAmount.toLocaleString()}
                  </span>
                </div>
              </div>

              <div className="donor-dash-new-reason-box">
                <label>Reason for Support</label>
                <p>{selectedStudent.reason}</p>
              </div>

              <div className="donor-dash-new-ngo-verify-box">
                <CheckCircle size={20} className="text-success" />
                <div>
                  <strong>Verified by {selectedStudent.ngo}</strong>
                  <small className="d-block text-muted">
                    {selectedStudent.documents} documents verified
                  </small>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
                Close
              </Button>
              <Button 
                className="donor-dash-new-modal-donate-btn"
                onClick={() => {
                  setShowDetailModal(false);
                  handleDonateToSchool(selectedStudent);
                }}
              >
                <Heart size={16} /> Donate to {selectedStudent.school}
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </DonorLayout>
  );
};

export default Dashboard;